"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.Form = styled_components_1.default.form `
  margin: 0 auto;
  box-sizing: border-box;
`;
